exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.frhomolo-login-wrapper[data-v-0c73f22e] {\n  width: 100%;\n}\n", ""]);

// exports
